// tslint:disable: max-line-length

// !WARNING! DO NOT EDIT THIS TEMPLATE EXCEPT YOU UNDERSTAND WHAT ARE YOU ACTUALLY DO.
// This is a "大鳴大放" template block, edit this and it will auto inject contents as popup-ready DOMElement.

const content = `
<script id="meta-content" type="application/json">
{
  "title": "大鳴大放",
  "description": "籌備中，敬請期待",
  "url": "https://sitcon.org/2020/cfp?popUp=loudly"
}
</script>
<h1 class="title font-black">籌備中，敬請期待</h1>
`;

export default content;
